// A local static build calls the backend on the same computer that serves
// the page. Using the page hostname also works when opened from another device.
export function resolveApiBases(config, location) {
  // Public HTTPS access must use the existing HTTPS gateway, never port 3300.
  // This also makes a local build safe to open through the public domain.
  if (config.apiMode === 'public' ||
      (config.localBackendPort && new URL(location.origin).protocol === 'https:')) {
    return { ddwn: '/api', cypher: '/api/cypher' };
  }
  if (config.localBackendPort) {
    const backend = new URL(location.origin);
    backend.port = config.localBackendPort;
    return { ddwn: backend.origin, cypher: `${backend.origin}/api/cypher` };
  }
  return {
    ddwn: (config.ddwnBase || 'https://ddwn.quelmarwiki.com/api').replace(/\/$/, ''),
    cypher: (config.cypherBase || '/api/cypher').replace(/\/$/, '')
  };
}

const bases = resolveApiBases({
  apiMode: process.env.REACT_APP_API_MODE,
  localBackendPort: process.env.REACT_APP_LOCAL_BACKEND_PORT,
  ddwnBase: process.env.REACT_APP_DDWN_API_BASE,
  cypherBase: process.env.REACT_APP_CYPHER_API_BASE
}, window.location);

export const DDWN_API_BASE = bases.ddwn;
export const CYPHER_API_BASE = bases.cypher;
